import React, { Component } from 'react';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

import styles from '../../../styles.js';

class CarTierCheckBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      radioValue: this.props.selectedTier
    };
  }

  componentWillMount() {
    const { handleTierFilter = () => {}, certification } = this.props;
    this.setState({ radioValue: certification ? 'Plus' : 'Pro' });
    handleTierFilter(certification ? 'Plus' : 'Pro');
  }

  componentWillReceiveProps(nextProps) {
    // if you navigate to /booking twice in one session, old settings remain, this clears back to default
    if (nextProps.selectedTier !== this.state.radioValue) {
      this.setState({ radioValue: nextProps.selectedTier });
    }
  }

  render() {
    const {
      handleTierFilter = () => {},
      openDialog,
      certification
    } = this.props;
    return (
      <div className="filter-container">
        <h4 className="filter-title">Tier</h4>
        <div className="filter-content">
          <RadioButtonGroup
            name="tier"
            labelPosition="left"
            onChange={(event, value) => {
              if (!(!certification && value === 'Plus')) {
                // in any case except uncertified AND clicking Plus
                this.setState({ radioValue: value });
                handleTierFilter(value);
              }
            }}
            valueSelected={this.state.radioValue}>
            <RadioButton
              label="Autzu Pro"
              value="Pro"
              labelPosition="left"
              iconStyle={styles.CheckboxFilterMui}
              inputStyle={styles.inputStyle}
              labelStyle={styles.LabelFilterMui}
            />
            <RadioButton
              label="Autzu Plus"
              value="Plus"
              onClick={() => {
                if (!certification) {
                  this.setState({ radioValue: 'Pro' });
                  openDialog('autzuPlus');
                }
              }}
              iconStyle={styles.CheckboxFilterMui}
              inputStyle={styles.inputStyle}
              labelStyle={styles.LabelFilterMui}
            />
          </RadioButtonGroup>
        </div>
      </div>
    );
  }
}

export default CarTierCheckBox;



// WEBPACK FOOTER //
// ./src/components/Book/FilterSidebar/CarTierCheckBox.js